/* -------------------------------------------------------------------------- */
/*                               Schema Locations                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const protocol = new schema.Entity('protocols', {}, { idAttribute: 'protocolId' });
export const protocols = new schema.Array(protocol);
